/**
 * @docs docs/features/api
 */

import { definePageRoute } from '@common/router/definitions';

/*----------------------------------
- ROUTE: API DOCUMENTATION QUICK START
----------------------------------*/

/*----------------------------------
- DEPENDANCES
----------------------------------*/

import {
    API_DOCUMENTATION_QUICK_START_ROUTE_OPTIONS,
    loadApiDocumentationRouteData,
    renderApiDocumentationQuickStartPage,
} from './lib/route';

/*----------------------------------
- ROUTE
----------------------------------*/

export default definePageRoute({
    path: '/api',
    options: API_DOCUMENTATION_QUICK_START_ROUTE_OPTIONS,
    data: loadApiDocumentationRouteData,
    render: renderApiDocumentationQuickStartPage,
});
